__turbopack_context__.v({
  "body_rich_text": "KPI-module-scss-module__BRfp0G__body_rich_text",
  "direction__column": "KPI-module-scss-module__BRfp0G__direction__column",
  "direction__row": "KPI-module-scss-module__BRfp0G__direction__row",
  "gradient-glow-blue": "KPI-module-scss-module__BRfp0G__gradient-glow-blue",
  "gradient-glow-neon": "KPI-module-scss-module__BRfp0G__gradient-glow-neon",
  "gradient-glow-orange": "KPI-module-scss-module__BRfp0G__gradient-glow-orange",
  "gradient-glow-pink": "KPI-module-scss-module__BRfp0G__gradient-glow-pink",
  "gradient-glow-snap-pea": "KPI-module-scss-module__BRfp0G__gradient-glow-snap-pea",
  "gradient-neon-pink": "KPI-module-scss-module__BRfp0G__gradient-neon-pink",
  "gradient-pink-blue": "KPI-module-scss-module__BRfp0G__gradient-pink-blue",
  "gradient-pink-orange": "KPI-module-scss-module__BRfp0G__gradient-pink-orange",
  "kpi-content-container": "KPI-module-scss-module__BRfp0G__kpi-content-container",
  "layout__content-leading": "KPI-module-scss-module__BRfp0G__layout__content-leading",
  "layout__content-trailing": "KPI-module-scss-module__BRfp0G__layout__content-trailing",
  "module-base": "KPI-module-scss-module__BRfp0G__module-base",
  "module-content-swap": "KPI-module-scss-module__BRfp0G__module-content-swap",
  "module_block__contained": "KPI-module-scss-module__BRfp0G__module_block__contained",
  "module_block__uncontained": "KPI-module-scss-module__BRfp0G__module_block__uncontained",
  "module_breadcrumbs": "KPI-module-scss-module__BRfp0G__module_breadcrumbs",
  "multi_kpi_container": "KPI-module-scss-module__BRfp0G__multi_kpi_container",
  "section_bg_fill__base": "KPI-module-scss-module__BRfp0G__section_bg_fill__base",
  "section_bg_fill__gradient": "KPI-module-scss-module__BRfp0G__section_bg_fill__gradient",
  "section_bg_fill__no-fill": "KPI-module-scss-module__BRfp0G__section_bg_fill__no-fill",
  "section_bg_fill__raised": "KPI-module-scss-module__BRfp0G__section_bg_fill__raised",
  "section_container": "KPI-module-scss-module__BRfp0G__section_container",
  "single-kpi-card-color": "KPI-module-scss-module__BRfp0G__single-kpi-card-color",
  "with_breadcrumb": "KPI-module-scss-module__BRfp0G__with_breadcrumb",
  "with_navbar": "KPI-module-scss-module__BRfp0G__with_navbar",
});
